import { Typography } from 'seagull/components/Typography';
import { validateReviewers } from "../../../../business-logic/draftLogic";
import AddAdditionalRecipients from "../../../../components/AgreementStudio/AddAdditionalRecipients/AddAdditionalRecipients";
import pluralize from "../../../../utils/pluralize";
import EditableTableCell from "../EditableTableCell/EditableTableCell";
import { jsx as _jsx } from "react/jsx-runtime";
export default function AdditionalRecipientsCell(_ref) {
  let {
    draft,
    contact,
    index,
    onOpenModal,
    isDisabled,
    disabledTooltip
  } = _ref;
  const numReviewers = draft.reviewers().length;
  const primaryContact = contact || undefined;
  return /*#__PURE__*/_jsx(EditableTableCell, {
    testid: "edit-additional-recipients-".concat(index),
    isDisabled: isDisabled,
    disabledTooltip: disabledTooltip,
    onClick: () => onOpenModal({
      width: '800px',
      shouldSubmit: draft => Promise.resolve(validateReviewers(draft.reviewers(), primaryContact)),
      renderContent: _ref2 => {
        let {
          wasSubmitted,
          draft,
          setDraft
        } = _ref2;
        return {
          title: 'Additional recipients',
          testid: "edit-additional-recipients-modal",
          onSubmit: defaultBehavior => {
            defaultBehavior();
          },
          content: /*#__PURE__*/_jsx(AddAdditionalRecipients, {
            initialState: draft.reviewers(),
            showReviewerErrors: wasSubmitted || undefined,
            primaryContact: primaryContact,
            onChange: newReviewers => setDraft(draft.setReviewers(newReviewers))
          })
        };
      }
    }),
    children: /*#__PURE__*/_jsx(Typography, {
      "data-testid": "additional-recipients-".concat(index),
      skin: numReviewers ? 'standard' : 'secondary',
      children: numReviewers ? pluralize('additional recipient', numReviewers, true) : 'Not set'
    })
  });
}